import {
  TAG_ACTION_STRINGS,
  TAG_SORT_OPTION_STRINGS,
  TAG_STRINGS
} from 'components/TagManager/constants';

export const LayoutStrings = {
  stepNames: {
    application: {
      details: 'Application Details'
    },
    workOrder: {
      details: 'Work Order Details'
    },
    selectProperties: 'Select Properties',
    selectProducts: 'Select Products',
    weather: 'Weather'
  },
  headers: {
    application: {
      info: 'APPLICATION INFO'
    },
    workOrder: {
      info: 'WORK ORDER INFO'
    },
    tags: 'TAGS',
    applicators: 'APPLICATORS',
    notes: 'NOTES',
    tankInformation: 'TANK INFORMATION'
  },
  fields: {
    application: {
      id: 'Application ID'
    },
    workOrder: {
      id: 'Work Order ID'
    },
    workType: 'Work Type',
    timingEvent: 'Timing Event',
    startDateTime: 'Start Date & Time',
    endDateTime: 'End Date & Time',
    duration: 'Duration',
    authorizationDate: 'Authorization Date',
    authorizedBy: 'Authorized by',
    applicationMethod: 'Application Method',
    equipment: 'Equipment',
    applicator: 'Applicator',
    company: 'Company'
  },
  placeholders: {
    application: {
      id: 'Application ID'
    },
    workOrder: {
      id: 'Work Order ID'
    },
    workType: 'General',
    timingEvent: 'Select timing event',
    startDateTime: 'MM-DD-YYYY hh:mmAM',
    endDateTime: 'MM-DD-YYYY hh:mmAM',
    authorizedBy: 'Select authorized person',
    applicationMethod: 'Select application method',
    selectApplicator: 'Select applicator',
    selectCompany: 'Select company',
    searchTags: TAG_ACTION_STRINGS.searchTags
  },
  errors: {
    durationPositive: 'Duration must be a positive number.',
    tankInfoIncomplete: 'Tank information is incomplete'
  },
  buttons: {
    application: {
      saveButton: 'Save Application'
    },
    workOrder: {
      saveButton: 'Save Work Order'
    },
    goBack: 'Go back',
    removeApplicator: 'Remove Applicator',
    addApplicator: 'Add Applicator',
    sort: TAG_ACTION_STRINGS.sort,
    manage: TAG_ACTION_STRINGS.manage,
    createNewTag: TAG_ACTION_STRINGS.createNewTag,
    learnMore: 'Learn More',
    changeSeason: 'Change season'
  },
  sortOptions: TAG_SORT_OPTION_STRINGS,
  modal: {
    application: {
      discardTitle: 'Discard Application?'
    },
    workOrder: {
      discardTitle: 'Discard Work Order?'
    },
    discardRecord: 'Discard record',
    continueEditing: 'Continue editing',
    cropSeasonSelectTitle: 'Change crop season?',
    cropSeasonSelectContent:
      'This will update your current properties selections.',
    noCropZonesTitle: 'No crop zones in selected seasons',
    noCropZonesContent:
      'None of the new crop season selections contained crop zones. To use a crop season on {entityType}, it needs to contain at least one crop zone.'
  },
  breadcrumb: {
    application: {
      label: 'Applications',
      createStep: 'Create Application',
      editStep: 'Edit Application'
    },
    workOrder: {
      label: 'Work Orders',
      createStep: 'Create Work Order',
      editStep: 'Edit Work Order'
    }
  },
  stepper: {
    application: {
      createTitle: 'Create Application',
      editTitle: 'Edit Application'
    },
    workOrder: {
      createTitle: 'Create Work Order',
      editTitle: 'Edit Work Order'
    }
  },
  tags: TAG_STRINGS,
  cropZones: {
    emptyStateTitle: 'No Crop Zones Selected',
    emptyStateMessage: 'Add crop zones to your record.',
    selectCropZones: 'Select Crop Zones',
    totalAppliedAcreage: 'Total Applied Acreage',
    areaUnit: 'acres',
    cropZonesCount: (count: number) => `Crop Zones (${count})`,
    cropZoneCrop: 'Crop',
    cropZoneFarm: 'Farm',
    archived: '(Archived)',
    // Edit modal strings
    editModal: {
      title: 'Edit Total Applied Acreage',
      description:
        'This will override any changes that have been made to individual crop zones.',
      totalAppliedAcres: 'Total Applied Acres',
      totalCoveragePercent: 'Total Coverage Percent',
      cancel: 'Cancel',
      save: 'Save'
    },
    // Individual crop zone edit modal strings
    cropZoneModal: {
      description:
        'Updating crop zone acreage on this record will not change the acreage elsewhere in Cropwise Financials.',
      cropZoneAcreage: 'Crop Zone Acreage',
      reportedArea: 'Reported Area',
      boundaryArea: 'Boundary Area',
      cancel: 'Cancel',
      save: 'Save'
    }
  },
  weather: {
    modal: {
      title: 'Automatic Weather Data',
      content: 'Weather data is provided by Iteris, powered by ClearAg.',
      additionalInfo:
        'If multiple fields are used on a record, weather data is taken from a center point between the fields.',
      closeButton: 'Close',
      learnMoreButton: 'Learn More'
    }
  },
  products: {
    emptyStateTitle: 'No Products Selected',
    emptyStateMessage: 'Add products to your application.',
    selectProduct: 'Select Product',
    selectProducts: 'Select Products',
    tableHeader: 'Products',
    productName: 'Product Name',
    manufacturer: 'Manufacturer',
    productType: 'Type',
    noProductsAvailable: 'No products available.',
    closeDrawer: 'Done',
    productDetails: {
      saveButton: 'Save Product Details',
      updateButton: 'Update Product Details',
      cancelEdition: 'Cancel',
      backButton: 'Back'
    },
    tankInfo: {
      overallRatePerAcreTooltip:
        'The combined rate of liquid products on this record',
      overallTotalProductTooltip:
        'The combined quantity of liquid products on this record',
      disabledSelectProductsButtonTooltip:
        'To add products, either fill out all Tank Information or set it to “OFF”',
      hiddenCarrierTooltip:
        'By hiding the carrier, it will not display on your record PDF or reports',
      selectCarrier: 'Select Carrier',
      saveCarrier: 'Save Carrier',
      selectCarrierErrorTitle: 'Unable to select carrier.',
      selectCarrierErrorContent:
        'An error prevented your carrier from being selected. Please try again.'
    }
  },
  modals: {
    buttonText: {
      continueEditing: 'Continue editing',
      saveApplication: 'Save Application'
    },
    discardPropertySelection: {
      title: 'Discard Property Selection?',
      content: 'Some property selections have not been saved to this record.',
      okText: 'Discard property selection',
      cancelText: 'Continue editing'
    }
  }
};

export default LayoutStrings;
